{
  "maximum": "Maksimi",
  "minimum": "Minimi"
}
